module.exports = __webpack_public_path__ + "static/TimHortons-cbe6b70c22dc38f9d328632f35b498e1.svg";